import Polyglot from "node-polyglot";
import defaultLocale from "./locales/en";
/*
 * Translation Utilty
 * Docs on interpolation https://airbnb.io/polyglot.js/#interpolation
 */ var polyglot = new Polyglot({
    locale: "en"
});
polyglot.extend(defaultLocale);
/*
 * @param {object<string, string>} can be used to override existing translations
 */ export var extend = polyglot.extend.bind(polyglot);
/*
 * Translation function
 * @param {string} key - the key to translate by
 */ export default polyglot.t.bind(polyglot);
